// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Ukraine from '../_raw/flag/icon_flag_ukraine.png';

export default () => <img src={Ukraine} alt="Ukraine" />;
